import * as React from "react";
const SvgRectangle = (props) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", height: 24, viewBox: "0 -960 960 960", width: 24, ...props }, /* @__PURE__ */ React.createElement("path", { d: "M80-160v-640h800v640H80Zm80-80h640v-480H160v480Zm0 0v-480 480Z" }));
export default SvgRectangle;
